/*
 * Oculta en el widget de Seal Subscriptions los planes «Pack…» (packs cafetera + café
 * con permanencia). Esos planes solo se contratan desde la sección de packs; en la ficha
 * de producto el cliente solo debe ver la compra única y las suscripciones normales.
 *
 * Seal pinta el widget por JS (.sealsubs-target-element) con un radio por grupo de planes
 * (data-selling-plan-group = índice en data-product.selling_plan_groups) y lo vuelve a
 * pintar al cambiar de variante, así que se reaplica con un MutationObserver.
 */
(function () {
  var KEYWORD = 'pack';

  function packIndexes(widget) {
    try {
      var data = JSON.parse(widget.getAttribute('data-product') || '{}');
      return (data.selling_plan_groups || []).reduce(function (acc, group, i) {
        if (String(group.name || '').toLowerCase().indexOf(KEYWORD) > -1) acc.push(String(i));
        return acc;
      }, []);
    } catch (e) {
      return [];
    }
  }

  function filter(widget) {
    var hide = packIndexes(widget);
    if (!hide.length) return;
    var resetToOneTime = false;
    // Fila completa del grupo (radio, nombre, precio y selector de intervalo)
    widget.querySelectorAll('.sls-option-container[data-selling-plan-group]').forEach(function (row) {
      if (hide.indexOf(row.getAttribute('data-selling-plan-group')) === -1) return;
      if (row.style.display !== 'none') {
        row.hidden = true;
        row.style.display = 'none';
      }
    });
    widget.querySelectorAll('input[data-selling-plan-group]').forEach(function (input) {
      if (hide.indexOf(input.getAttribute('data-selling-plan-group')) === -1) return;
      // Marcado antiguo de Seal sin .sls-option-container: ocultar el contenedor más cercano
      if (!input.closest('.sls-option-container')) {
        var option = input.parentElement && input.parentElement.closest('.sls-option') || input.parentElement;
        if (option) { option.hidden = true; option.style.display = 'none'; }
      }
      if (input.checked) resetToOneTime = true;
    });
    if (resetToOneTime) {
      var visible = widget.querySelector('input[data-type="one_time"]') ||
        Array.prototype.find.call(widget.querySelectorAll('input[data-selling-plan-group]'), function (i) {
          return hide.indexOf(i.getAttribute('data-selling-plan-group')) === -1;
        });
      if (visible) visible.click();
    }
  }

  function run() {
    document.querySelectorAll('.sealsubs-target-element[data-product]').forEach(filter);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; run(); });
  }

  function start() {
    run();
    if ('MutationObserver' in window) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
